<template>
  <div class="tweet-page">
    <menubar></menubar>
    <div v-if="listDesctiption" class="list-desc">{{listDesctiption}}</div>
    <tweet-list ref="list"
      :listType="listType"
      :initialPos="initialScrollTop"
    ></tweet-list>
  </div>
</template>

<style scoped>
  .tweet-page {
    height: 100%;
    padding-top: 40px;
  }
  .list-desc {
    font-size: 9pt;
    color: gray;
  }
</style>

<script>
import TweetList from '@/components/TweetList'
import Menubar from '@/components/Menubar'
import * as atypes from '@/store/action-types'
export default {
  name: 'ListPage',
  components: {TweetList, Menubar},
  props: {
    initialListType: String
  },
  computed: {
    initialScrollTop () { return this.$store.getters.TweetListPage_getScPos || 0 },
    listType () { return this.$store.state.TweetListPage.listType },
    listDesctiption () {
      return {
        myimgs: 'Twitterに投稿した画像',
        favs: 'Twitterでファボ♡した画像',
        stocks: 'colorincoでストック☆した画像'
      }[this.listType] || null
    }
  },
  methods: {
    saveState () {
      this.$store.dispatch(atypes.TWEETLISTPAGE_SET_SCPOS, this.$refs.list.getScrollPos())
    }
  },
  mounted () {
    console.log('mounted')
    const type = this.$route.path.substr(1)
    this.$store.dispatch(atypes.TWEETLISTPAGE_CHANGE_TYPE, {type})
  },
  watch: {
    '$route' (to, from) {
      console.log('detect route change:', to, from)
      const type = to.path.substr(1)
      this.saveState()
      this.$store.dispatch(atypes.TWEETLISTPAGE_CHANGE_TYPE, {type})
    }
  },
  beforeDestroy () {
    this.saveState()
  },
  deactivated () {
    this.saveState()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ListPage.vue